import React from 'react';
import { BarChart3 } from 'lucide-react';
import { WidgetCard } from '../ui/WidgetCard';
export function RoyaltyKpiWidget() {
  return <WidgetCard title="Royalties Summary" icon={<BarChart3 size={18} className="text-[#376770]" data-id="element-97" />} data-id="element-96">
      <div className="space-y-5" data-id="element-98">
        <div className="flex flex-col items-center" data-id="element-99">
          <div className="text-xl font-medium text-[#376770]" data-id="element-100">€7,540</div>
          <div className="text-sm text-gray-500 mt-1" data-id="element-101">Total revenue</div>
        </div>
        <div className="flex flex-col space-y-3" data-id="element-102">
          <StatusCard label="Active contracts" count="3" data-id="element-103" />
          <StatusCard label="Average royalty" count="31.7%" data-id="element-104" />
          <StatusCard label="Last month" count="€495" data-id="element-105" />
        </div>
      </div>
    </WidgetCard>;
}
function StatusCard({
  label,
  count
}) {
  return <div className="flex items-center py-3 border-t border-gray-100" data-id="element-106">
      <div className="flex-1" data-id="element-107">
        <div className="text-sm font-medium text-gray-700" data-id="element-108">{label}</div>
      </div>
      <div className="text-lg font-normal text-[#376770]" data-id="element-109">{count}</div>
    </div>;
}